goog.provide("shadow.js.shim.module$react_dropzone_new");
goog.provide("module$shadow_js_shim_module$react_dropzone_new");
shadow.js.shim.module$react_dropzone_new = shadow.js.nativeProvides["react-dropzone-new"] = shadow$bridge("react-dropzone-new");
module$shadow_js_shim_module$react_dropzone_new.default = shadow.js.shim.module$react_dropzone_new;
